<script lang="ts">
  import SectionBoard from "../../molecules/SectionBoard.svelte";
  import { onMount } from "svelte";
  import BlueButton from "../BlueButton.svelte";
  import { RecruitmentService } from "../../services/recruitment.service";
  import WorkingHour from "./WorkingHour.svelte";
  import Title from "./Title.svelte";
  import Detail from "./Detail.svelte";
  import Image from "./Image.svelte";
  import YearlyIncome from "./YearlyIncome.svelte";
  import Prefecture from "./Prefecture.svelte";
  import Municipality from "./Municipality.svelte";
  import Transportation from "./Transportation.svelte";
  import EmploymentStatus from "./EmploymentStatus.svelte";
  import WorkStyle from "./WorkStyle.svelte";
  import Qualification from "./Qualification.svelte";
  import JobRole from "./JobRole.svelte";
  import Subject from "./Subject.svelte";
  import FacilityForm from "./FacilityForm.svelte";
  import Feature from "./Feature.svelte";
  import Salary from "./Salary.svelte";
  import Workplace from "./Workplace.svelte";
  import Holiday from "./Holiday.svelte";
  import JobDescription from "./JobDescription.svelte";
  import ApplicationCondition from "./ApplicationCondition.svelte";
  import Allowance from "./Allowance.svelte";
  import Welfare from "./Welfare.svelte";
  import Disabled from "./Disabled.svelte";
  import DisabledCompany from "./DisabledCompany.svelte";
  import Attention from "./Attention.svelte";
  import Company from "./Company.svelte";
  import Memo from "./Memo.svelte";

  const name = "recruitment";
  const label = "求人登録";

  const service = new RecruitmentService(name);
  let loading = service.store.loading;
  let prefectureUnselected = service.store.prefectureUnselected;
  let model = service.store.model;
  onMount(async () => {
    await service.getOptions();
  });
</script>

<SectionBoard>
  <h2 class="font-semibold">
    {label}
  </h2>

  <Image {service} klass="mt-6" />
  <Memo {service} klass="mt-6 mb-2" />
  <Title {service} klass="mt-6 mb-2" />
  <Company {service} klass="mt-6 mb-2" />
  <Detail {service} klass="mt-6 mb-2" />
  <YearlyIncome {service} klass="mt-6" />
  <Prefecture {service} klass="mt-6" />
  <Municipality {service} klass="mt-6" />
  <Transportation {service} klass="mt-6" />
  <EmploymentStatus {service} klass="mt-6" />
  <WorkStyle {service} klass="mt-6" />
  <Qualification {service} klass="mt-6 mb-2" />
  <JobRole {service} klass="mt-6 mb-2" />
  <Subject {service} klass="mt-6 mb-2" />
  <FacilityForm {service} klass="mt-6 mb-2" />
  <Feature {service} klass="mt-6 mb-2" />
  <Salary {service} klass="mt-6 mb-2" />
  <WorkingHour {service} klass="text-sm mt-6 mb-2" />
  <Workplace {service} klass="mt-6 mb-2" />
  <Holiday {service} klass="mt-6 mb-2" />
  <JobDescription {service} klass="mt-6 mb-2" />
  <ApplicationCondition {service} klass="mt-6 mb-2" />
  <Allowance {service} klass="mt-6 mb-2" />
  <Welfare {service} klass="mt-6 mb-2" />
  <Disabled {service} klass="mt-6 mb-2" />
  <DisabledCompany {service} klass="mt-6 mb-2" />
  <Attention {service} klass="mt-6 mb-2" />

  <BlueButton
    rounded
    klass="mt-4"
    click={service.create}
    loading={$loading}
    disabled={$prefectureUnselected === $model.prefectures[0]}
  >
    登録する
  </BlueButton>
</SectionBoard>
